<ps-ui-modal>
  <ps-ui-modal-body>
    <p class="lableText">
      {{ text }}
    </p>
  </ps-ui-modal-body>
  <ps-ui-modal-footer>
    <button
      type="button"
      psUiButton
      color="secondary"
      (click)="close('yes')"
      class="btn btn-default footer-btn yesBtn"
    >
      {{ confirmButtonLabel }}
    </button>
    <button
      type="button"
      class="btn btn-default footer-btn noBtn"
      psUiButton
      (click)="close('no')"
    >
      {{ declineButtonLabel }}
    </button>
    <button
      type="button"
      class="btn btn-default footer-btn cancelBtn"
      psUiButton
      (click)="close('cancel')"
    >
      Cancel
    </button>
  </ps-ui-modal-footer>
</ps-ui-modal>
